import { FillButton } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext, ZIndexContext } from "./../../../../../ricos-context";
import { ADD_CUSTOM_COLOR_BUTTON } from "../../data-hooks";
const AddColorButton = ({ onAddClick, setRef }) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  return /* @__PURE__ */ React.createElement("div", { ref: setRef }, /* @__PURE__ */ React.createElement(
    FillButton,
    {
      iconSize: "medium",
      onClick: onAddClick,
      dataHook: ADD_CUSTOM_COLOR_BUTTON,
      tooltipContent: t("ColorPickerAddCustomColor_Tooltip"),
      tooltipProps: {
        appendTo: (el) => Boolean(el.getAttribute("data-hook")?.includes("ricos-portal")),
        zIndex: zIndexService.getZIndex("TOOLTIP"),
        moveBy: { y: 10 }
      },
      role: "option",
      tabIndex: 0,
      "aria-label": t("ColorPickerAddCustomColor_Tooltip")
    }
  ));
};
export {
  AddColorButton
};
//# sourceMappingURL=add-color-button.js.map
